import { UserPermissions, User } from '../../types/shared/User';

export function canUser(
  user: User | null | undefined,
  checkPermissions: Partial<UserPermissions>,
) {
  if (!user) {
    return false;
  }
  let currentPermissions = user.permissions;
  let checkPermissionKeys = Object.keys(checkPermissions);
  for (let permissionKey of checkPermissionKeys) {
    let checkPermissionLevel = checkPermissions[permissionKey];
    let currentPermissionLevel = currentPermissions?.[permissionKey];
    if (
      (checkPermissionLevel === 'READ' && currentPermissionLevel === 'WRITE') ||
      checkPermissionLevel === currentPermissionLevel
    ) {
      continue;
    }
    return false;
  }
  return true;
}
